document.addEventListener('DOMContentLoaded', function () {
  (function restoreUpsellButtonLabels() {
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || '';
    var addToCartLabel = locale.toLowerCase().indexOf('en') === 0 ? 'ADD TO CART' : 'ADAUGA IN COS';
    var headingMarkers = ['ADAUGA ACCESORIU', 'ADD ACCESSORY'];
    var totalMarkers = ['PRET TOTAL', 'TOTAL PRICE'];
    var pending = false;

    function containsAnyMarker(node, markers) {
      var text = (node.textContent || '').toUpperCase();
      return markers.some(function (marker) {
        return text.indexOf(marker) !== -1;
      });
    }

    function hasVisibleBox(node) {
      var box = node.getBoundingClientRect();
      return box.width > 40 && box.height > 20;
    }

    function readElementText(node) {
      if (!node) {
        return '';
      }

      if (node.tagName === 'INPUT') {
        return node.value || '';
      }

      return node.textContent || '';
    }

    function writeElementText(node, label) {
      if (node.tagName === 'INPUT') {
        node.value = label;
        return;
      }

      var childText = node.querySelector('span, div');
      if (childText && (readElementText(childText).trim() === '' || childText.textContent.trim() === '+')) {
        childText.textContent = label;
        childText.style.textIndent = '0';
        childText.style.fontSize = '14px';
        childText.style.lineHeight = '1.2';
      } else {
        node.textContent = label;
      }
    }

    function isLikelyPrimaryUpsellCta(node) {
      if (!node || !hasVisibleBox(node)) {
        return false;
      }

      var rect = node.getBoundingClientRect();
      if (rect.width < 140 || rect.height < 30) {
        return false;
      }

      var text = readElementText(node).trim();
      if (text !== '' && text !== '+') {
        return false;
      }

      var disabledAttr = (node.getAttribute('disabled') || '').toLowerCase();
      return disabledAttr !== 'true';
    }

    function isLargeEmptyCta(node) {
      if (!node || !hasVisibleBox(node)) {
        return false;
      }

      var rect = node.getBoundingClientRect();
      if (rect.width < 180 || rect.height < 34) {
        return false;
      }

      var classes = ((node.className && node.className.baseVal) || node.className || '').toString().toLowerCase();
      var id = (node.id || '').toLowerCase();

      if (classes.indexOf('swatch') !== -1 || classes.indexOf('quantity') !== -1 || classes.indexOf('qty') !== -1) {
        return false;
      }

      if (id.indexOf('quantity') !== -1 || id.indexOf('qty') !== -1) {
        return false;
      }

      var text = readElementText(node).trim();
      return text === '' || text === '+';
    }

    function collectUpsellRoots() {
      var roots = [];

      document.querySelectorAll('h1, h2, h3, h4, h5, strong, p, div, span').forEach(function (el) {
        if (!containsAnyMarker(el, headingMarkers) && !containsAnyMarker(el, totalMarkers)) {
          return;
        }

        var root = el.closest('form, .product-single__form, .product-block, .product__main-photos, .page-content, .shopify-section') || el.parentElement;
        if (root && roots.indexOf(root) === -1) {
          roots.push(root);
        }
      });

      return roots;
    }

    function restoreLabelsInRoot(root) {
      var candidates = root.querySelectorAll('button, a[role="button"], a.btn, input[type="button"], input[type="submit"], div[role="button"], span[role="button"], [class*="button"], [class*="btn"]');

      candidates.forEach(function (candidate) {
        if (!isLikelyPrimaryUpsellCta(candidate)) {
          return;
        }

        writeElementText(candidate, addToCartLabel);
        candidate.style.textIndent = '0';
        candidate.style.color = 'inherit';
        candidate.style.fontSize = '14px';
        candidate.style.lineHeight = '1.2';

        if (!candidate.getAttribute('aria-label')) {
          candidate.setAttribute('aria-label', addToCartLabel);
        }
      });
    }

    function restoreLabels() {
      pending = false;
      collectUpsellRoots().forEach(restoreLabelsInRoot);

      // Last-resort fallback: some app blocks inject non-standard empty CTA nodes.
      document.querySelectorAll('button, a[role="button"], a.btn, input[type="button"], input[type="submit"], div[role="button"], span[role="button"], [class*="button"], [class*="btn"]').forEach(function (candidate) {
        if (!isLargeEmptyCta(candidate)) {
          return;
        }

        writeElementText(candidate, addToCartLabel);
        candidate.style.textIndent = '0';
        candidate.style.color = 'inherit';
        candidate.style.fontSize = '14px';
        candidate.style.lineHeight = '1.2';

        if (!candidate.getAttribute('aria-label')) {
          candidate.setAttribute('aria-label', addToCartLabel);
        }
      });
    }

    function scheduleRestore() {
      if (pending) {
        return;
      }

      pending = true;
      window.requestAnimationFrame(restoreLabels);
    }

    restoreLabels();
    new MutationObserver(scheduleRestore).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  })();

  var stickyBars = document.querySelectorAll('[data-mobile-sticky-atc]');

  if (!stickyBars.length) {
    return;
  }

  stickyBars.forEach(function (bar) {
    var form = bar.closest('form');

    if (!form) {
      return;
    }

    var mainButton = form.querySelector('[data-add-to-cart]');
    var mainButtonText = form.querySelector('[data-add-to-cart-text]');
    var stickyButton = bar.querySelector('[data-sticky-atc-button]');
    var stickyButtonText = bar.querySelector('[data-sticky-atc-text]');
    var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
    var productSection = form.closest('[data-section-type="product"]') || document;
    var livePrice = productSection.querySelector('[data-product-price]');
    var mobileQuery = window.matchMedia('(max-width: 768px)');
    var mainButtonVisible = true;
    var formTop = form.getBoundingClientRect().top + window.scrollY;

    if (!mainButton || !stickyButton || !stickyButtonText || !stickyPrice) {
      return;
    }

    function syncState() {
      if (mainButtonText) {
        stickyButtonText.textContent = mainButtonText.textContent.trim();
      }

      stickyButton.disabled = mainButton.disabled;

      if (livePrice) {
        stickyPrice.innerHTML = livePrice.innerHTML;
      }
    }

    function updateVisibility() {
      var isMobile = mobileQuery.matches;
      var scrolledPastForm = window.scrollY > formTop + 140;
      var nearPageBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 140;
      var shouldShow = isMobile && scrolledPastForm && !mainButtonVisible && !nearPageBottom;

      bar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('has-mobile-sticky-atc', shouldShow);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        mainButtonVisible = entry.isIntersecting;
        updateVisibility();
      });
    }, {
      threshold: 0.35
    });

    observer.observe(mainButton);

    stickyButton.addEventListener('click', function (evt) {
      if (stickyButton.disabled) {
        evt.preventDefault();
        return;
      }

      if (mainButton !== stickyButton) {
        mainButton.click();
        evt.preventDefault();
      }
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', function () {
      formTop = form.getBoundingClientRect().top + window.scrollY;
      updateVisibility();
    });

    document.addEventListener('variant:change', function () {
      syncState();
      window.requestAnimationFrame(updateVisibility);
    });

    syncState();
    updateVisibility();
  });
});
